<div class="notes"
     tooltipShow="true"
     genTooltip
     [ngClass]="{'hasNotes': aberration.hasNotes,'disable': isAdminUser()}"
     [tooltipPosition]="'TOP'"
     [tooltipText]="(lastTooltipText ? lastTooltipText : tooltipText | async) | removeHtmlTags"
     [maxTooltipHeight]="maxTooltipHeight"
     [maxTooltipWidth]="maxTooltipWidth">
    <i class="icon__notifications" (click)="openPopup($event)">
        <span class="new-notes-notification-count" *ngIf="newNotesCount > 0">{{newNotesCount}}</span>
    </i>
</div>
